// Generated by packages/brand-kit (`yarn workspace @pft-platform/brand-kit build`). Do not edit.
// Aspect ratios (width / height) of the console logos (spec 008 research R-07).

export const brandGeometry = {
  L1: {
    aspect: 2.2886,
  },
  L4: {
    aspect: 6.681,
  },
  emblem: {
    aspect: 1,
  },
} as const;
